import React, { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { firebaseApp } from '../../firebase';
import AdminLogin from '../../components/AdminPanel/AdminLogin';
import AdminPanelDashboard from '../../components/AdminPanel/AdminPanelDashboard';

const AdminPanel: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const auth = getAuth(firebaseApp);
  const db = getFirestore(firebaseApp);

  useEffect(() => {
    // Listen to Firebase auth state changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Check if the authenticated user is an admin
        try {
          const adminDocRef = doc(db, 'admins', user.uid);
          const adminDoc = await getDoc(adminDocRef);
          
          if (adminDoc.exists()) {
            setIsAuthenticated(true);
            sessionStorage.setItem('admin_authenticated', 'true');
          } else {
            setIsAuthenticated(false);
            sessionStorage.removeItem('admin_authenticated');
            // Sign out non-admin user
            await signOut(auth);
          }
        } catch (error) {
          setIsAuthenticated(false);
          sessionStorage.removeItem('admin_authenticated');
        }
      } else {
        setIsAuthenticated(false);
        sessionStorage.removeItem('admin_authenticated');
      }
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, [auth, db]);

  const handleLogin = (authenticated: boolean) => {
    if (authenticated) {
      setIsAuthenticated(true);
      sessionStorage.setItem('admin_authenticated', 'true');
    } else {
      setIsAuthenticated(false);
      sessionStorage.removeItem('admin_authenticated');
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsAuthenticated(false);
      sessionStorage.removeItem('admin_authenticated');
    } catch (error) {
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading admin panel...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return (
    <div>
      <AdminPanelDashboard />
      {/* Logout button in the dashboard */}
      <button
        onClick={handleLogout}
        className="fixed top-4 right-4 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors shadow-lg z-50"
      >
        Logout
      </button>
    </div>
  );
};

export default AdminPanel;
